export default [
    {
        path: "/marketplace/feedback",
        name: "feedback",
        component: () => import("@/views/marketplace/feedback/AppFeedback"),
    },
];
